import { FormikErrors } from 'formik'
import { useState } from 'react'
import { removeElementAtIndex } from '../../helpers'
import { useModalControl } from '../../hooks/useModalControl'
import {
  CreateProductValues,
  Product,
} from '../../redux-toolkits/products/products.type'
import { Accordion } from '../accordion'
import { Button } from '../button'
import { SelectProductModal } from '../modal/app_modals/selectProductModal'
import { ProductTileContainer } from './productTile'

export const ManageProductSuggestions = ({
  values,
  setFieldValue,
  productDetails,
}: {
  values: CreateProductValues
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean,
  ) => Promise<void> | Promise<FormikErrors<CreateProductValues>>
  productDetails?: Product
}) => {
  const [activeSection, setActiveSection] = useState<
    'addOns' | 'recommendedProducts'
  >('recommendedProducts')

  const { handleModalOpen, setModalOpen, modal, modalOpen, handleModalClose } =
    useModalControl()

  return (
    <div className="flex flex-col gap-10">
      <Accordion title="Recommended Items">
        <div className="w-full flex flex-col gap-6">
          <div className="w-full flex items-center justify-end">
            <Button
              label="Add Products"
              primary
              onClick={() => {
                handleModalOpen('addProductsModal')
                setActiveSection('recommendedProducts')
              }}
            />
          </div>

          <ProductTileContainer
            products={values.recommendedProducts ?? []}
            handleSortEnd={(products) => {
              setFieldValue('recommendedProducts', products)
            }}
            canDelete
            onDeleteProduct={(p, idx) => {
              const productsCopy = JSON.parse(
                JSON.stringify(values.recommendedProducts ?? []),
              )
              setFieldValue(
                'recommendedProducts',
                removeElementAtIndex(productsCopy, idx),
              )
            }}
            sortable
          />
        </div>
      </Accordion>

      <Accordion title="Add ons">
        <div className="w-full flex flex-col gap-6">
          <div className="w-full flex items-center justify-end">
            <Button
              label="Add Products"
              primary
              onClick={() => {
                handleModalOpen('addProductsModal')
                setActiveSection('addOns')
              }}
            />
          </div>

          <ProductTileContainer
            products={values.addOns ?? []}
            handleSortEnd={(products) => {
              setFieldValue('addOns', products)
            }}
            canDelete
            onDeleteProduct={(p, idx) => {
              const productsCopy = JSON.parse(
                JSON.stringify(values.addOns ?? []),
              )
              setFieldValue('addOns', removeElementAtIndex(productsCopy, idx))
            }}
            sortable
          />
        </div>
      </Accordion>

      <SelectProductModal
        open={modalOpen && modal === 'addProductsModal'}
        setOpen={setModalOpen}
        onCloseCallback={() => {}}
        onSuccessCallback={(products) => {
          if (activeSection === 'addOns') {
            setFieldValue('addOns', products)
          }
          if (activeSection === 'recommendedProducts') {
            setFieldValue('recommendedProducts', products)
          }
          handleModalClose()
        }}
        selectedProducts={
          activeSection === 'addOns'
            ? values.addOns
            : values.recommendedProducts
        }
        excludedProducts={[productDetails?._id ?? '']}
      />
    </div>
  )
}
